module.exports = __webpack_public_path__ + "0e1dd6d896ec1acf1c4c8ee87b06517a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/codmw/logosoon.jpg
// module id = 1035
// module chunks = 0